import { getSiteUrl } from './site-url';

const maxGenerators = 5;
const maxGeneratorLength = 200;
const reportedFlag = '__cognitoPlatformReported';

function readGenerators(): string[] {
	const generators: string[] = [];
	const tags = document.getElementsByTagName('meta');
	for (let i = 0; i < tags.length && generators.length < maxGenerators; i++) {
		if ((tags[i].getAttribute('name') || '').toLowerCase() !== 'generator')
			continue;

		const generator = (tags[i].getAttribute('content') || '').trim();
		if (generator && generator.length <= maxGeneratorLength && generators.indexOf(generator) < 0)
			generators.push(generator);
	}

	return generators;
}

function isHostedElsewhere(siteUrl: string) {
	return new URL(siteUrl).origin !== window.location.origin;
}

export function readHostGenerators(): string[] {
	const siteUrl = getSiteUrl();
	if (!siteUrl || !isHostedElsewhere(siteUrl))
		return [];

	return readGenerators();
}

function send(url: string, generators: string[]) {
	const request = new XMLHttpRequest();
	request.open('POST', url, true);
	request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	request.send(generators.map(generator => 'generators=' + encodeURIComponent(generator)).join('&'));
}

/**
 * Reports the generator meta tags of a page that embeds a form in an iframe, since the form inside the frame
 * cannot read them, so that the platform the site was built with can be named. The report carries the tag
 * values alone: the site they describe is derived from the request, never sent. Pages we serve ourselves
 * report nothing, and a page is reported once per organization.
 */
export function reportHostPlatform(apiKey: string) {
	const siteUrl = getSiteUrl();
	if (!apiKey || !siteUrl || !isHostedElsewhere(siteUrl))
		return;

	const reported: Record<string, boolean> = window[reportedFlag] || (window[reportedFlag] = {});
	if (reported[apiKey])
		return;

	const report = () => {
		const generators = readGenerators();
		if (!generators.length || reported[apiKey])
			return;

		reported[apiKey] = true;
		send(siteUrl + 'svc/load-form/report-platform/' + encodeURIComponent(apiKey), generators);
	};

	if (document.readyState === 'loading')
		document.addEventListener('DOMContentLoaded', report, { once: true });
	else
		report();
}
